<template>
  <div v-if="data" class="ps">
    <div ref="productSlider" class="ps__products-wrapper swiper-container">
      <div :class="['ps__products', {'ps__products--center': data.products.length < 4}]">
        <div v-for="(product,index) in  data.products" :key="index" class="ps__product">
          <ProductCard
            :product="product"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, toRefs, ref, onMounted } from 'vue';
  import ProductCard from '../global/product-card.vue';
  import Swiper from 'swiper';

  const props = defineProps({
    data: {
      type: Object,
      default: () => ({})
    }
  })

  const { data } = toRefs(props)
  
  onMounted(() =>{
    new Swiper(productSlider.value, productCarousel.value);
    window.refreshYotpoData();
  })

  var productSlider = ref(null);

  const productCarousel = computed(() => {
    return {
      slidesPerView: data.value.slidesPerViewMobile,
      spaceBetween: 16,
      wrapperClass: 'ps__products',
      slideClass: 'ps__product', 
      breakpoints: {
        768:{
          slidesPerView: data.value.slidesPerViewTablet,
          spaceBetween: 32
        },
        1024:{
          slidesPerView: data.value.slidesPerViewDesktop,
          spaceBetween: 32
        } 
      }
    }
  })
</script>